import React from "react";
import CultureFlag from "components/Culture/CultureFlag";
import { Panel } from "components/panels";

export const CultureListApp = () => {
  return <Panel
    panelClassName="s1_listview-panel"
    title={RESX.Cultures.xCultures}
    headerSize="h1"
  >
    <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">                        {
        window.serverReference.cultures.map((c: server.dto.Culture, key) =>
          <div key={key}>
            <div><CultureFlag lcid={c.value} size="large" /></div>
            <div style={{ flex: "3 1 0%" }}><div className="table-main-link">{c.text}</div></div>
            <div style={{ flex: "1 1 0%" }}>{c.locale}</div>
            <div style={{ flex: "1 1 0%" }}>{c.value}</div>
          </div>
        )}
      </div>
    </div>
  </Panel>
}